import DatamodelPage from "@/platform/components/datamodel/datamodel-page";

const EventDetails = () => {
    return (
    <div className="event-details-page">
      <DatamodelPage datamodelType="event" />  
    </div>
  );
};

export default EventDetails;